"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvoiceStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useInvoiceStore = (0, pinia_1.defineStore)('invoiceStore', {
    state: () => ({
        invoices: [],
        invoiceItems: []
    }),
    getters: {
        getInvoices: (state) => state.invoices,
        getInvoiceItems: (state) => state.invoiceItems,
    },
    actions: {
        async fetchInvoices(router, query, customerId) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'axapta_invoices_api', query: { ...query, customerId: customerId } }).href);
                this.invoices = response;
                return response;
            }
            catch (error) {
                console.error("Failed to fetch invoices:", error);
                throw error;
            }
        },
        async fetchInvoiceItems(router, params = {}) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'axapta_invoice_items_api', query: params }).href);
                this.invoiceItems = response;
                return response;
            }
            catch (error) {
                console.error("Failed to fetch invoice items:", error);
                throw error;
            }
        },
        async sendInvoiceCopyInEmail(router, payload) {
            try {
                const options = { body: JSON.stringify(payload), method: 'POST' };
                const response = await (0, fetch_1.default)(router.resolve({ name: 'axapta_send_invoice_copy_in_email_api' }).href, options);
                if (response.status !== 'success') {
                    throw new Error(response.error);
                }
                return response;
            }
            catch (error) {
                console.error("Failed to send invoice copy in email:", error);
                throw error;
            }
        },
        resetInvoices() {
            this.invoices = [];
        },
        resetInvoiceItems() {
            this.invoiceItems = [];
        },
        reset() {
            this.invoices = [];
            this.invoiceItems = [];
        }
    }
});
